<template name="alertModalSecurity">
  <div v-show="isModalShown" class="security-modal">
    <div class="modal-wrapper" :class="`${modalType}-wrapper`">
      <i class="iconfont icon-close" @click="closeSecurityModal"></i>
      <div class="modal-icon">
        <img src="../assets/images/security/face-recognition-passed.png" v-if="modalStatus && modalType === 'faceRecognition'">
        <img src="../assets/images/security/face-recognition-failed.png" v-if="!modalStatus && modalType === 'faceRecognition'">

        <img src="../assets/images/security/bind-card-passed.png" v-if="modalStatus && (modalType === 'bindCard' || modalType === 'printCard')">
        <img src="../assets/images/security/bind-card-failed.png" v-if="!modalStatus && (modalType === 'bindCard' || modalType === 'printCard')">

        <img src="../assets/images/security/verify-passed.png" v-if="modalStatus && modalType === 'verify'">
        <img src="../assets/images/security/verify-failed.png" v-if="!modalStatus && modalType === 'verify'">
      </div>
      <div class="modal-title" :class="`${modalType}-title`">
        <h3>{{ modalTitle }}</h3>
        <p class="title-desc">{{ errMsg }}</p>
      </div>
      <div class="modal-operation" @click="executeOperation">
        {{  btnName }}
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
/**
 * Bind modalType, modalStatus, modalTitle, btnName, errMsg, isModalShown, closeSecurityModal/executeOperation handler
 * Basic usage:
  <alertModalSecurity
    :modalType="'faceRecognition'"
    :modalStatus="faceRecognitionStatus"
    :errMsg="faceRecognitionErr"
    :isModalShown="isFaceRecognitionShown"
    @closeSecurity="handleClose"
    @executeOperation="handleOperation"
  >

  </alertModalSecurity>
 */
export default {
  name: 'alertModalSecurity',
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    isModalShown: Boolean,
    modalType: String,
    modalTitle: String,
    errMsg: String,
    btnName: String,
    modalStatus: Boolean,
  },
  methods: {
    closeSecurityModal() {
      this.$emit('closeSecurityModal');
    },
    executeOperation() {
      this.$emit('executeOperation');
    },
  },
};
</script>
<style scoped lang="scss">
  .security-modal {
    background-color: rgba(34, 34, 34, 0.55);
    height: 100vh;
    z-index: 2000;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    position: fixed;
  }
  .modal-wrapper {
    .icon-close {
      font-size: 30px;
      position: absolute;
      right: 15px;
      top: 5px;
    }
    width: 43.9%;
    height: 545px;
    background: #fff;
    border-radius: 12px;
    padding: 90px 0;
    text-align: center;
    position: relative;
    &.verify-wrapper {
      padding: 75px 0;
    }
    .modal-icon {
      width: 30%;
      margin: auto;
      img {
        width: 100%;
      }
    }
    .modal-title {
      color: #4a4a4a;
      margin-top: 50px;
      &.verify-title {
        margin-top: 35px;
      }
      h3 {
        font-size: 30px;
        font-weight: bold;
      }
      p {
        font-size: 16px;
        padding-left: 15%;
        padding-right: 15%;
      }
    }
    .modal-operation {
      width: 64%;
      margin: auto;
      border-radius: 5px;
      background-image: linear-gradient(80deg, #f36443, #e42029);
      color: #fff;
      line-height: 46px;
      font-size: 15px;
      margin-top: 50px;
    }
  }
</style>
